@if (!isVoid) {
  <div class="gravimetric-widget-container no-page-break">
    @if (showHeader) {
      <div class="widget-header no-page-break">
        <div class="header-left"></div>
        <div class="header-right">
          <span class="duration-label">{{ durationLabel }}:</span>
          @if (duration) {
            <span class="duration-value">{{ duration }}</span>
          }
        </div>
      </div>
    }
    <!-- Jurisdiction boxes — each jurisdiction in its own section with agents + legend -->
    @if (jurisdictionGroups?.length) {
      <div>
        @for (jGroup of jurisdictionGroups; track trackByIndex($index)) {
          <div class="jurisdiction-box no-page-break"
            [style.margin-bottom]="'20px'" [style.padding]="'12px 15px'"
            [style.border]="'1px solid #e5e7eb'" [style.border-radius]="'8px'"
            [style.page-break-inside]="'avoid'" [style.break-inside]="'avoid'">
            <div class="jurisdiction-box-header"
              [style.font-size]="'13px'" [style.font-weight]="'600'"
              [style.color]="'#374151'" [style.margin-bottom]="'10px'"
              [style.padding-bottom]="'6px'" [style.border-bottom]="'1px solid #e5e7eb'">
              {{ jurisdictionLabel }}: {{ jGroup.jurisdictionName }}
            </div>
            <div class="agent-cards-grid" [class.compact]="cardTemplate === 'compact'"
              [style.font-size]="'0'" [style.display]="'block'">
              @for (agent of jGroup.agents; track trackByIndex(i); let isLast = $last; let i = $index) {
                <div class="agent-card no-page-break"
                  [class.full-width]="isLast && (jGroup.agents.length % 2 === 1)" [class.compact]="cardTemplate === 'compact'"
                  [attr.data-exposure]="getExposureLevel(agent.maxExposurePercentage)"
                  [style.border]="'1px solid ' + agent.maxExposureColor"
                  [style.border-left]="'6px solid ' + agent.maxExposureColor"
                  [style.margin]="(i % 2 === 1) ? '8px 0 8px 0' : '8px 15px 8px 0'" [style.display]="'inline-block'"
                  [style.width]="'calc(50% - 15px)'"
                  [style.min-height]="'160px'"
                  [style.vertical-align]="'top'" [style.font-size]="'14px'" [style.padding]="'12px 10px 10px 10px'"
                  [style.page-break-inside]="'avoid'" [style.break-inside]="'avoid'" [style.box-sizing]="'border-box'"
                  [style.position]="'relative'" [style.overflow]="'visible'">
                  <div class="agent-header" [class.compact]="cardTemplate === 'compact'">
                    <div class="agent-info">
                      <span class="agent-label">{{ analyteLabel | uppercase }}</span>
                      <h3 class="agent-name">{{ agent.agentName }}</h3>
                    </div>
                  </div>
                  <div class="jurisdictions-section">
                    @for (jurisdiction of agent.jurisdictions; track trackByIndex($index); let isLastJurisdiction = $last) {
                      <div class="jurisdiction-item"
                        [class.mb-3]="!isLastJurisdiction">
                        @if (!jurisdiction.isLoq) {
                          @if (isNoiseSample) {
                            <div class="oel-percentage-header" [class.compact]="cardTemplate === 'compact'">
                              <span class="oel-percentage-label">{{ dosePercentLabel }}</span>
                              <span class="oel-percentage-value">{{ jurisdiction.rawDosePercentage != null ? ((jurisdiction.rawDosePercentage | number:'1.1-1') + '%') : '-' }}</span>
                            </div>
                            <div class="oel-percentage-header" [class.compact]="cardTemplate === 'compact'">
                              <span class="oel-percentage-label">{{ shiftAdjustedDosePercentLabel }}</span>
                              <span class="oel-percentage-value" [style.color]="jurisdiction.exposureColor">
                                {{ jurisdiction.shiftAdjustedDosePercentage != null ? ((jurisdiction.shiftAdjustedDosePercentage | number:'1.1-1') + '%') : '-' }}
                              </span>
                            </div>
                          } @else {
                            <div class="oel-percentage-header" [class.compact]="cardTemplate === 'compact'">
                              <span class="oel-percentage-label">{{ percentageOfOelLabel }}</span>
                              <span class="oel-percentage-value" [style.color]="jurisdiction.exposureColor">
                                {{ jurisdiction.exposurePercentage | number:'1.1-1' }}%
                              </span>
                            </div>
                          }
                          <div class="twa-section" [class.compact]="cardTemplate === 'compact'">
                            <div class="twa-header">
                              <span class="twa-value">
                                @if (jurisdiction.showCensorSymbol) {
                                  <span class="censor-symbol">{{
                                  jurisdiction.censorSymbol }}</span>
                                  }{{ isNoiseSample ? (jurisdiction.ihLabResult.twa | number:'1.1-1') : (jurisdiction.convertedTwa | number:'1.0-4') }}
                                </span>
                                <span class="twa-unit">{{ isNoiseSample ? dbaTwaLabel : getUnitSymbol(agent.agentUnits) }}</span>
                              </div>
                              <div class="progress-container" [class.compact]="cardTemplate === 'compact'">
                                <div class="progress-bar">
                                  <div class="progress-fill" [style.width.%]="jurisdiction.progressWidth"
                                  [style.background-color]="jurisdiction.exposureColor"></div>
                                  <div class="oel-marker" [style.left.%]="jurisdiction.oelPosition"></div>
                                </div>
                                <div class="progress-dashed-line"></div>
                              </div>
                              <div class="bottom-info" [class.compact]="cardTemplate === 'compact'">
                                <span class="oel-info">
                                  {{ oelLabel }}{{ jurisdiction.oelLabel }}:
                                  {{ jurisdiction.effectiveOelValue | number:(isNoiseSample ? '1.0-2' : '1.0-4') }}
                                  {{ isNoiseSample ? dbaLabel : getUnitSymbol(agent.agentUnits) }}
                                </span>
                              </div>
                            </div>
                          } @else {
                            <div class="twa-section" [class.compact]="cardTemplate === 'compact'">
                              <div class="twa-header">
                                <span class="twa-value" [style.color]="jurisdiction.exposureColor" [style.font-size]="'16px'">{{ loqDisplayText }}</span>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              <!-- Legend for this jurisdiction -->
              @if (jGroup.legendItems?.length) {
                <div class="risk-legend-container"
                  [style.margin-top]="'8px'" [style.padding-top]="'6px'" [style.border-top]="'1px solid #e5e7eb'">
                  <span class="legend-title">{{ isNoiseSample ? riskLegendDoseLabel : riskLegendOelLabel }}</span>
                  <div class="legend-items">
                    @for (item of jGroup.legendItems; track trackByIndex($index)) {
                      <div class="legend-item">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span class="legend-text">{{ item.text }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (!jurisdictionGroups?.length && !groupedAgents?.length) {
        <div class="no-data">
          <h3>{{ isNoiseSample ? noNoiseResultsLabel : noLabResultLabel }}</h3>
        </div>
      }
    </div>
  }

  @if (isVoid) {
    <div class="void-card">
      <h3 class="void-title">{{ sampleVoidedLabel }}</h3>
      @if (voidReason) {
        <p class="void-reason"><strong>{{ voidReasonLabel }}:</strong> {{ voidReason }}</p>
      }
    </div>
  }
